import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'upgrade-onboarding-experiment.refresh-flag.title',
		defaultMessage: '{product} has been upgraded to Standard',
		description: 'Title for flag informing user their product has been upgraded to Standard',
	},
	contentText: {
		id: 'upgrade-onboarding-experiment.refresh-flag.content-text',
		defaultMessage: 'We need to refresh Jira to get you started with the Standard plan.',
		description:
			'Message informing user that a refresh of Jira is necessary to start using the Standard plan',
	},
	refreshPage: {
		id: 'upgrade-onboarding-experiment.refresh-flag.refresh-page',
		defaultMessage: 'Refresh Jira',
		description: 'Text for button to refresh Jira',
	},
	iconLabel: {
		id: 'upgrade-onboarding-experiment.refresh-flag.icon-label',
		defaultMessage: 'Refresh Jira',
		description: 'Alt Label for Icon for flag informing user to refresh jira',
	},
});
